import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import TableManage from '@/product/views/Settings/TableSettings/TableManage'
import * as Yup from 'yup'

const BannerImage = (props) => {
    const [fieldValue, setFieldValue] = useState([
        {
            label: props?.includeVideo
                ? 'Desktop Banner Image/Video *'
                : 'Desktop Banner Image *',
            type: 'uploadDropZone',
            accept: props?.includeVideo ? 'image/*,video/*' : 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: props?.includeVideo
                ? 'Add a banner image/video with aspect ratio of 16:5'
                : 'Add a banner image with aspect ratio of 16:5',
            class: 'col-sm-6 col-12',
            name: 'image',
            is_required: true,
        },
        {
            label: props?.includeVideo
                ? 'Mobile Banner Image/Video'
                : 'Mobile Banner Image',
            type: 'uploadDropZone',
            accept: props?.includeVideo ? 'image/*,video/*' : 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: props?.includeVideo
                ? 'Add a banner image/video with aspect ratio of 8:5'
                : 'Add a banner image with aspect ratio of 8:5',
            class: 'col-sm-6 col-12',
            name: 'image_mobile',
            is_required: false,
        },
        {
            label: 'Title',
            type: 'text',
            placeholder: 'Enter the title',
            class: 'col-sm-6 col-12',
            name: 'title',
            isRequired: false,
        },
        {
            label: 'Description',
            type: 'textarea',
            placeholder: 'Enter the description',
            class: 'col-12',
            name: 'description',
            isRequired: false,
        },
        {
            label: 'Button label',
            type: 'text',
            placeholder: 'Enter the button label',
            class: 'col-sm-6 col-12',
            name: 'button_label',
            isRequired: false,
        },
        {
            label: 'Button link',
            type: 'text',
            placeholder: 'Enter the button link',
            class: 'col-sm-6 col-12',
            name: 'link',
            isRequired: false,
        },
        {
            label: 'Button color',
            type: 'colorpicker',
            placeholder: 'Enter the link',
            class: 'col-sm-6 col-12',
            name: 'color',
            isRequired: false,
        },
    ])

    useEffect(() => {
        if (props.extraBannerFields && props.extraBannerFields.length > 0) {
            setFieldValue((prevState) => {
                const existingFieldNames = new Set(
                    prevState.map((field) => field.name)
                )
                const newFields = props.extraBannerFields.filter(
                    (field) => !existingFieldNames.has(field.name)
                )
                return newFields.length > 0
                    ? [...prevState, ...newFields]
                    : prevState
            })
        }
    }, [props.extraBannerFields])

    const validationArray = {
        title: Yup.string().max(30, 'A maximum of 30 characters is allowed!'),
        description: Yup.string().max(
            60,
            'A maximum of 60 characters is allowed!'
        ),
    }

    return (
        <Layout>
            <TableManage
                variableName="allHomeBanner"
                tableName="home_banner"
                tableHeading="Banner Image"
                customValidation={validationArray}
                arrayValue={fieldValue}
                ignoreField={{
                    enabled: 1,
                    field: 'active',
                    value: 2,
                }}
            ></TableManage>
        </Layout>
    )
}

export default BannerImage
